import isNil from 'lodash/isNil';
import React from 'react';

import { useGetOfferingStatus } from '../hooks/useGetOfferingStatus';

export type Props = ReturnType<typeof useGetOfferingStatus>;

const SupersededOfferingContext = React.createContext<Props>({
  isFiledOffering: false,
});

export const useSupersededOfferingContext = () => {
  const context = React.useContext(SupersededOfferingContext);

  if (isNil(context)) {
    throw new Error('No Provider found for SupersededOfferingContext');
  }

  return context;
};

export const SupersededOfferingProvider: React.FC<React.PropsWithChildren<{ data: Props }>> = ({
  children,
  data,
}) => {
  return (
    <SupersededOfferingContext.Provider value={data}>{children}</SupersededOfferingContext.Provider>
  );
};
